import request from '@/utils/request'

// 获取userInfo
export const getInfoByXjuTicket = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/login/xjuTicket',
		method: 'GET',
		params: data
	})
}

// 获取公文
export const getXxfwList = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/newoa/sys/newxjwj/xjwjCommonApi/getXxfwList.do',
		method: 'GET',
		params: data
	})
}

// 获取消息
export const getNotice = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/app/getnotice',
		method: 'POST',
		data: data
	})
}

// 获取小程序缓存
export const getWXCatch = (key, toekn) => {
	return request<any>({
		url: '/api/xjuappgw/h5/api/forward/cache?key=' + key,
		method: 'GET',
		headers: {
			xjuToken: toekn ? toekn : null
		},
	})
}

// 获取公文详情
export const getXxfwDetail = (id: any, xjuToken?: any) => {
	return request<any>({
		url: `/api/xjuappgw/h5/bizForward/newoa/sys/zhuozheng/viewPdf/${id}.do`,
		headers: {
			xjuToken: xjuToken ? xjuToken : null
		},
		method: 'GET',
		responseType: 'blob'
	})
}

// 获取我发起的任务
export const getMyProcessTaskData = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/taskcenterapp/sys/taskCenter/taskPush/getMyProcessData.do',
		method: 'POST',
		params: data
	})
}

// 获取我待办的任务
export const getTodoTaskData = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/taskcenterapp/sys/taskCenter/taskPush/getTodoTaskData.do',
		method: 'POST',
		params: data
	})
}

// 获取已办的任务
export const getDoneTaskData = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/taskcenterapp/sys/taskCenter/taskPush/getDoneTaskData.do',
		method: 'POST',
		params: data
	})
}

// 宣传报道
export const getXxfbList = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/newoa/sys/newoaxxfb/xxfbCommonApi/getXxfbList.do',
		method: 'GET',
		params: data
	})
}

// 微服务菜单
export const appServiceMenuAPI = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/app/appServiceMenuAPI',
		method: 'POST',
		data: data
	})
}

// 我的微服务菜单
export const myAppServiceMenuAPI = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/app/lookMyServiceAPI',
		method: 'POST',
		data: data
	})
}

// 修改我的微服务菜单
export const editMyAppServiceMenuAPI = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/app/editServiceAPI',
		method: 'POST',
		data: data
	})
}

// 我发起的审批流程详情
export const getFlowRecord = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/bizForward/taskcenterapp/sys/taskCenter/taskNew/getFlowRecord.do',
		method: 'POST',
		data: data,
		loading: true
	})
}

// 下载附件
export const attachmentDownload = (url) => {
	return request<any>({
		url,
		method: 'GET',
		responseType: 'blob'
	})
}

export const logout = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/login/logout',
		method: 'GET',
		params: data,
		loading: true
	})
}

// oauth登录token换code
export const getAuthCode = (data: any) => {
	return request<any>({
		url: '/api/xjuappgw/h5/login/getAuthCode',
		method: 'GET',
		params: data
	})
}
